'use strict';

(function init($) {
  $(document).ready(function () {
    $('.slider-hero').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false
    });
    $('.slider-sponsors').slick({
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000
        }
      }]
    });

    //   $(window).load(() => {
    //     if ($('#subscribe-popup').length > 0) {
    //       $.magnificPopup.open({
    //         items: {
    //           src: '#subscribe-popup'
    //         },
    //         type: 'inline'
    //       }, 0);
    //   }
    // });
  });
})(jQuery);
"use strict";

jQuery(document).foundation();
'use strict';

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function () {
  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Makes sure last grid item floats left
  jQuery('.archive-grid .columns').last().addClass('end');

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if (jQuery(undefined).innerWidth() / jQuery(undefined).innerHeight() > 1.5) {
      jQuery(undefined).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(undefined).wrap("<div class='flex-video'/>");
    }
  });
});